<!-- task-board.component.html -->
<div class="container mx-auto px-4">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <!-- Titre de la section -->
    <h2 class="text-xl font-bold text-gray-800">{{ t('taskBoard.title') }}</h2>

    <!-- Bouton -->
    <button (click)="openCreateModal()" class="h-11 px-5
           bg-orange-500 hover:bg-orange-600
           text-white rounded-lg
           flex items-center gap-2
           text-sm font-medium
           transition-colors whitespace-nowrap shadow-sm">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.85714 9.14286H1.14286C0.819051 9.14286 0.547813 9.03314 0.329147 8.81371C0.11048 8.59429 0.000765845 8.32305 3.94088e-06 8C-0.000757964 7.67695 0.108956 7.40571 0.329147 7.18629C0.549337 6.96686 0.820575 6.85714 1.14286 6.85714H6.85714V1.14286C6.85714 0.819051 6.96686 0.547813 7.18629 0.329147C7.40571 0.11048 7.67695 0.000765845 8 3.94088e-06C8.32305 -0.000757964 8.59467 0.108956 8.81486 0.329147C9.03505 0.549337 9.14438 0.820575 9.14286 1.14286V6.85714H14.8571C15.1809 6.85714 15.4526 6.96686 15.672 7.18629C15.8914 7.40571 16.0008 7.67695 16 8C15.9992 8.32305 15.8895 8.59467 15.6709 8.81486C15.4522 9.03505 15.1809 9.14438 14.8571 9.14286H9.14286V14.8571C9.14286 15.1809 9.03314 15.4526 8.81371 15.672C8.59429 15.8914 8.32305 16.0008 8 16C7.67695 15.9992 7.40571 15.8895 7.18629 15.6709C6.96686 15.4522 6.85714 15.1809 6.85714 14.8571V9.14286Z"
          fill="white" />
      </svg>

      {{ t('taskBoard.newTask') }}
    </button>
  </div>


  <!-- Error Message -->
  <div *ngIf="errorMessage"
    class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 flex justify-between items-center">
    <span>{{ errorMessage }}</span>
    <button (click)="clearError()" class="text-red-500 hover:text-red-700">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  </div>

  <!-- Success Message -->
  <div *ngIf="successMessage"
    class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4 flex justify-between items-center">
    <span>{{ successMessage }}</span>
    <button (click)="clearSuccess()" class="text-green-500 hover:text-green-700">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="loading" class="flex justify-center items-center py-8">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
  </div>

  <!-- Task Board -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-start" *ngIf="!loading">
    <!-- Task Columns -->
    <div *ngFor="let column of columns; trackBy: trackByColumnId"
      class="bg-[#f4f5fc] rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col h-fit"
      (dragover)="onDragOver($event, column.id)" (drop)="onDrop($event, column.id)">

      <!-- Column Header -->
      <div class="flex items-center justify-between mb-6">
        <div class="flex items-center gap-3">
          <div class="w-5 h-5 flex-shrink-0">
            <svg *ngIf="column.color === 'gray'" width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8 0.75C12.0041 0.75 15.25 3.99594 15.25 8C15.25 12.0041 12.0041 15.25 8 15.25C3.99594 15.25 0.75 12.0041 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75Z"
                stroke="#5B6069" stroke-width="1.5" />
            </svg>

            <svg *ngIf="column.color === 'yellow-400'" width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8 0C6.94943 -1.2528e-08 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C1.60028 3.08601 1.011 3.96793 0.608964 4.93853C0.206926 5.90914 -3.33941e-08 6.94943 0 8C3.33941e-08 9.05058 0.206926 10.0909 0.608964 11.0615C1.011 12.0321 1.60028 12.914 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16L8 8V0Z"
                fill="#F5C402" />
              <circle cx="8" cy="8" r="7.25" stroke="#F5C402" stroke-width="1.5" />
            </svg>

            <svg *ngIf="column.color === 'red-400'" width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8 0.75C12.0041 0.75 15.25 3.99594 15.25 8C15.25 12.0041 12.0041 15.25 8 15.25C3.99594 15.25 0.75 12.0041 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75Z"
                stroke="#EF4444" stroke-width="1.5" />
            </svg>

            <svg *ngIf="column.color === 'green-400'" width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="8" cy="7.87692" rx="8" ry="7.87692" fill="#55A684" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.34446 8.71657C3.5347 8.52633 3.84315 8.52633 4.03339 8.71657L6.28703 10.9702L12.4378 4.81942C12.6281 4.62918 12.9365 4.62918 13.1267 4.81942C13.317 5.00966 13.317 5.3181 13.1267 5.50834L6.63149 12.0036C6.44125 12.1938 6.13281 12.1938 5.94257 12.0036L3.34446 9.4055C3.15422 9.21526 3.15422 8.90681 3.34446 8.71657Z"
                fill="white" />
            </svg>
          </div>

          <h3 class="font-semibold text-gray-700 text-lg">{{ column.title }}</h3>
          <span class="bg-gray-100 text-gray-600 text-sm px-3 py-1 rounded-full font-medium">{{ column.count }}</span>
        </div>
        <button (click)="openCreateModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
        </button>
      </div>

      <!-- Task Cards Container avec scroll -->
      <style>
        .task-scroll-container::-webkit-scrollbar {
          width: 5px;
        }

        .task-scroll-container::-webkit-scrollbar-track {
          background: transparent;
        }

        .task-scroll-container::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 10px;
        }

        .task-scroll-container::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      </style>
      <div class="space-y-4 flex-1 overflow-y-auto pr-1 task-scroll-container"
        [style.max-height]="column.tasks.length > 3 ? '520px' : 'auto'">
        <div *ngFor="let task of column.tasks; trackBy: trackByTaskId"
          class="bg-white border border-gray-200 rounded-xl p-5 transition-all duration-300 cursor-pointer w-full hover:shadow-xl hover:scale-[1.05] hover:border-orange-200 transform"
          draggable="true" (dragstart)="onDragStart($event, task)" (dragend)="onDragEnd($event)"
          (click)="openDetailModal(task)" [ngClass]="{'opacity-50': isDragging && draggedTask?.id === task.id}">

          <!-- Task Image (if available) -->
          <div *ngIf="task.pictures && task.pictures.length > 0" class="mb-4">
            <img [src]="getFileBaseUrl() + task.pictures[0]" [alt]="task.title"
              class="w-full h-40 object-cover rounded-lg">
          </div>

          <!-- Assigned Users -->
          <div *ngIf="task.assignedUsers && task.assignedUsers.length > 0" class="flex items-center gap-2 mb-3">
            <div *ngFor="let user of task.assignedUsers; let i = index"
              class="w-8 h-8 rounded-full bg-gray-200 border-2 border-white overflow-hidden"
              [style.margin-left.px]="i > 0 ? -8 : 0" [style.z-index]="task.assignedUsers.length - i">
              <img [src]="user.avatarUrl" [alt]="user.name" class="w-full h-full object-cover"
                (error)="onImageError($event)">
            </div>
            <span *ngIf="task.additionalUsers > 0" class="text-xs text-gray-600 font-medium">
              +{{ task.additionalUsers }}
            </span>
          </div>

          <!-- Task Title -->
          <h4 class="font-bold text-gray-900 text-sm mb-2 line-clamp-2 hover:text-orange-500 transition-colors">
            {{ task.title }}
          </h4>

          <!-- Task Description -->
          <p class="text-xs text-gray-600 mb-3 line-clamp-2">{{ task.description }}</p>

          <!-- Task Tag -->
          <div class="mb-3">
            <span class="inline-block text-xs px-2 py-1 rounded font-medium"
              [ngClass]="[task.tag.colorClass, task.tag.textColorClass]">
              {{ task.tag.name }}
            </span>
          </div>

          <!-- Task Meta Information -->
          <div class="flex items-center justify-between text-xs text-gray-500">
            <div class="flex items-center gap-3">
       

              <!-- Attachments Icon -->
              <div class="flex items-center gap-1 hover:text-orange-500 transition-colors cursor-pointer"
                (click)="openFileModal(task); $event.stopPropagation()">
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.391 6.97407L7.69099 13.6907C6.39099 14.9901 4.27633 14.9901 2.97699 13.6907C1.67766 12.3914 1.67699 10.2761 2.97699 8.97606L10.0623 1.9194C10.8423 1.1394 12.111 1.1394 12.891 1.9194C13.6703 2.6994 13.671 3.9674 12.891 4.7474L7.21966 10.3901C6.95966 10.6501 6.53699 10.6501 6.27699 10.3901C6.01699 10.1301 6.01699 9.7074 6.27699 9.4474L11.0057 4.7474L10.0623 3.80473L5.33366 8.50406C4.55233 9.2854 4.55299 10.5527 5.33366 11.3334C6.11433 12.1141 7.38099 12.1141 8.16166 11.3334L13.833 5.69073C14.4843 5.0394 14.809 4.18673 14.809 3.3334C14.809 1.4874 13.3117 0.000732422 11.4757 0.000732422C10.6223 0.000732422 9.76966 0.326066 9.11833 0.977399L2.03366 8.03273C1.12299 8.94473 0.666992 10.1387 0.666992 11.3334C0.666992 13.9087 2.75366 16.0001 5.33366 16.0001C6.52833 16.0001 7.72233 15.5441 8.63366 14.6334L15.3337 7.91673L14.391 6.97407Z"
                    fill="currentColor" />
                </svg>
                <span>{{ task.attachments }}</span>
              </div>

              <!-- Edit Icon -->
              <div class="flex items-center gap-1 hover:text-blue-500 transition-colors cursor-pointer"
                (click)="openEditModal(task); $event.stopPropagation()" title="Modifier la tâche">
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L5.33301 13.3334L1.33301 14.6667L2.66634 10.6667L11.333 2.00004Z"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                    fill="none" />
                </svg>
              </div>
            </div>

            <!-- Due Date -->
            <div class="flex items-center gap-1 bg-gray-50 px-2 py-0.5 rounded shadow-sm">
              <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16 1.33333V16H0V1.33333H2V2C2 2.73533 2.598 3.33333 3.33333 3.33333C4.06867 3.33333 4.66667 2.73533 4.66667 2V1.33333H11.3333V2C11.3333 2.73533 11.9313 3.33333 12.6667 3.33333C13.402 3.33333 14 2.73533 14 2V1.33333H16ZM14.6667 5.33333H1.33333V14.6667H14.6667V5.33333Z"
                  fill="currentColor" />
              </svg>
              <span>{{ task.dueDate }}</span>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="column.tasks.length === 0"
          class="text-center py-12 text-gray-500 h-full flex flex-col justify-center">
          <svg class="w-16 h-16 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2">
            </path>
          </svg>
          <p class="text-base font-medium">{{ t('taskBoard.task.noTasks') }}</p>
          <p class="text-sm mt-1">{{ t('taskBoard.task.clickToAdd') }}</p>
        </div>
      </div>

      <!-- Indicateur Voir plus -->
      <div *ngIf="column.tasks.length > 3" class="mt-4 pt-4 border-t border-gray-200 flex justify-center">
        <div class="flex items-center gap-2 text-gray-400 animate-pulse">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
          <span class="text-[10px] uppercase tracking-wider font-bold">{{ t('taskBoard.task.scrollMore') }}</span>
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Pagination globale -->
  <div *ngIf="totalPages > 1" class="flex justify-center items-center gap-4 mt-8">
    <button (click)="previousPage()" [disabled]="currentPage === 0"
      class="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
      {{ t('common.previous') }}
    </button>

    <span class="text-sm text-gray-600 font-medium">
      {{ t('projects.page') }} {{ currentPage + 1 }} {{ t('projects.on') }} {{ totalPages }}
    </span>

    <button (click)="nextPage()" [disabled]="currentPage >= totalPages - 1"
      class="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
      {{ t('common.next') }}
    </button>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════
     MODAL CRÉATION / MODIFICATION DE TÂCHE
     ═══════════════════════════════════════════════════════════════ -->
<div *ngIf="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
  (click)="onBackdropClick($event)">

  <div class="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[92vh] flex flex-col overflow-hidden"
    (click)="closeWorkerDropdownOnOutsideClick($event)">

    <!-- ── Header ── -->
    <div class="flex justify-between items-center px-7 py-5 border-b border-gray-100 flex-shrink-0">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 bg-orange-100 rounded-lg flex items-center justify-center">
          <svg class="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
        </div>
        <h2 class="text-lg font-bold text-gray-900">
          {{ isEditMode ? t('taskBoard.editTask') : t('taskBoard.newTask') }}
        </h2>
      </div>
      <button (click)="closeModal()"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- ── Body scrollable ── -->
    <div class="flex-1 overflow-y-auto px-7 py-6">

      <!-- Message d'erreur -->
      <div *ngIf="error"
        class="mb-4 flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
        <svg class="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd" />
        </svg>
        <p class="text-sm text-red-700">{{ error }}</p>
      </div>

      <form (ngSubmit)="saveTask()" #taskForm="ngForm" class="space-y-5">

        <!-- Titre -->
        <div>
          <label for="title" class="block text-sm font-semibold text-gray-700 mb-1.5">
            {{ t('taskBoard.form.title') }} <span class="text-orange-500">*</span>
          </label>
          <input type="text" id="title" [(ngModel)]="currentTask.title" name="title" required
            class="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all placeholder-gray-400"
            [placeholder]="t('taskBoard.form.title')">
        </div>

        <!-- Description -->
        <div>
          <label for="description" class="block text-sm font-semibold text-gray-700 mb-1.5">
            {{ t('taskBoard.form.description') }} <span class="text-orange-500">*</span>
          </label>
          <textarea id="description" [(ngModel)]="currentTask.description" name="description" required rows="3"
            class="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all resize-none placeholder-gray-400"
            [placeholder]="t('taskBoard.form.description')"></textarea>
        </div>

        <!-- Priorité -->
        <div>
          <label for="priority" class="block text-sm font-semibold text-gray-700 mb-1.5">
            {{ t('taskBoard.form.priority') }}
          </label>
          <select id="priority" [(ngModel)]="currentTask.priority" name="priority"
            class="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all bg-white">
            <option value="LOW">{{ t('taskBoard.priority.LOW') }}</option>
            <option value="MEDIUM">{{ t('taskBoard.priority.MEDIUM') }}</option>
            <option value="HIGH">{{ t('taskBoard.priority.HIGH') }}</option>
          </select>
        </div>

        <!-- Dates sur 2 colonnes -->
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label for="startDate" class="block text-sm font-semibold text-gray-700 mb-1.5">
              {{ t('taskBoard.form.startDate') }} <span class="text-orange-500">*</span>
            </label>
            <input type="date" id="startDate" [(ngModel)]="currentTask.startDate" name="startDate" required [min]="minDate"
              class="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all">
          </div>
          <div>
            <label for="endDate" class="block text-sm font-semibold text-gray-700 mb-1.5">
              {{ t('taskBoard.form.endDate') }} <span class="text-orange-500">*</span>
            </label>
            <input type="date" id="endDate" [(ngModel)]="currentTask.endDate" name="endDate" required
              class="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all">
          </div>
        </div>

        <!-- Statut (mode édition uniquement) -->
        <div *ngIf="isEditMode">
          <label for="status" class="block text-sm font-semibold text-gray-700 mb-1.5">
            {{ t('taskBoard.form.status') }}
          </label>
          <select id="status" [(ngModel)]="currentTask.status" name="status"
            class="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all bg-white">
            <option value="TODO">{{ getStatusColumnTitle('TODO') }}</option>
            <option value="IN_PROGRESS">{{ getStatusColumnTitle('IN_PROGRESS') }}</option>
            <option value="BLOCKED">{{ getStatusColumnTitle('BLOCKED') }}</option>
            <option value="DONE">{{ getStatusColumnTitle('DONE') }}</option>
          </select>
        </div>

        <!-- ── Images (remonté avant les exécuteurs) ── -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-1.5">
            {{ t('taskBoard.form.images') }}
          </label>
          <div
            class="border-2 border-dashed border-gray-200 rounded-xl p-5 text-center hover:border-orange-400 hover:bg-orange-50 transition-all group">
            <input type="file" id="files" (change)="onFileSelected($event)" multiple accept="image/*" class="hidden">
            <label for="files" class="cursor-pointer flex flex-col items-center">
              <svg class="w-9 h-9 text-gray-300 group-hover:text-orange-400 transition-colors mb-2" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span class="text-sm text-orange-500 font-medium group-hover:text-orange-600 transition-colors">
                {{ t('taskBoard.form.clickToAddImages') }}
              </span>
              <span class="text-xs text-gray-400 mt-0.5">{{ t('taskBoard.form.imageFormat') }}</span>
            </label>
          </div>

          <!-- Fichiers sélectionnés -->
          <div *ngIf="selectedFiles.length > 0" class="mt-3 flex flex-wrap gap-2">
            <div *ngFor="let file of selectedFiles; let i = index"
              class="flex items-center gap-2 bg-gray-50 border border-gray-200 px-3 py-1.5 rounded-lg text-sm">
              <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span class="text-gray-700 max-w-[140px] truncate">{{ file.name }}</span>
              <button type="button" (click)="removeFile(i)" class="text-gray-400 hover:text-red-500 transition-colors">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- ══════════════════════════════════════════════════════
             EXÉCUTEURS — Auto-complétion avec toggle (en dernier)
             ══════════════════════════════════════════════════════ -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-1.5">
            {{ t('taskBoard.form.assignUsers') }}
          </label>

          <!-- Badge des sélectionnés -->
          <div *ngIf="currentTask.executors.length > 0" class="flex flex-wrap gap-2 mb-3">
            <div *ngFor="let executor of currentTask.executors"
              class="flex items-center gap-2 bg-orange-50 border border-orange-200 px-3 py-1.5 rounded-full">
              <img [src]="executor.photo ? getFileBaseUrl() + executor.photo : '/avatar-placeholder.svg'"
                class="w-5 h-5 rounded-full border border-orange-200 object-cover" (error)="onImageError($event)">
              <span class="text-sm font-medium text-orange-700">{{ executor.prenom }} {{ executor.nom }}</span>
              <button type="button" (click)="removeExecutor(executor.id)"
                class="w-4 h-4 flex items-center justify-center rounded-full text-orange-400 hover:text-white hover:bg-orange-500 transition-all">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Champ de recherche -->
          <div class="relative worker-dropdown-container">
            <div class="relative">
              <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input type="text" [(ngModel)]="workerSearchKeyword" (input)="onWorkerSearch(workerSearchKeyword)"
                (focus)="focusWorkerInput()" name="workerSearch" placeholder="Rechercher un salarié..."
                autocomplete="off"
                class="w-full pl-9 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#28396C] focus:border-transparent transition-all placeholder-gray-400">
            </div>

            <!-- Dropdown -->
            <div *ngIf="showWorkerDropdown && (availableWorkers.length > 0 || workerLoading)"
              class="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden"
              (scroll)="onWorkerScroll($event)">

              <div class="max-h-52 overflow-y-auto">
                <div *ngFor="let worker of availableWorkers" (click)="toggleWorkerSelection(worker)"
                  class="flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors"
                  [ngClass]="isWorkerAlreadySelected(worker.id)
                    ? 'bg-orange-50 hover:bg-orange-100'
                    : 'hover:bg-gray-50'">

                  <!-- Avatar -->
                  <img [src]="worker.photo ? getFileBaseUrl() + worker.photo : '/avatar-placeholder.svg'"
                    class="w-8 h-8 rounded-full border-2 object-cover flex-shrink-0 transition-colors"
                    [ngClass]="isWorkerAlreadySelected(worker.id) ? 'border-orange-400' : 'border-gray-200'"
                    (error)="onImageError($event)">

                  <!-- Infos -->
                  <div class="flex-1 min-w-0">
                    <div class="text-sm font-medium text-gray-800 truncate">{{ worker.prenom }} {{ worker.nom }}</div>
                    <div class="text-xs text-gray-400 truncate">{{ worker.email }}</div>
                  </div>

                  <!-- Indicateur coché / non coché -->
                  <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all"
                    [ngClass]="isWorkerAlreadySelected(worker.id)
                      ? 'bg-orange-500 border-orange-500'
                      : 'border-gray-300'">
                    <svg *ngIf="isWorkerAlreadySelected(worker.id)" class="w-3 h-3 text-white" fill="none"
                      stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                </div>

                <!-- Loading -->
                <div *ngIf="workerLoading" class="flex items-center justify-center py-4 gap-2 text-gray-400 text-sm">
                  <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-500"></div>
                  Chargement...
                </div>

                <!-- Aucun résultat -->
                <div *ngIf="!workerLoading && availableWorkers.length === 0"
                  class="py-6 text-center text-sm text-gray-400">
                  Aucun ouvrier trouvé
                </div>
              </div>

              <!-- Footer indicatif -->
              <div class="px-4 py-2 bg-gray-50 border-t border-gray-100 flex items-center justify-between">
                <span class="text-xs text-gray-400">
                  {{ currentTask.executors.length }} sélectionné(s)
                </span>
                <button type="button" (click)="showWorkerDropdown = false"
                  class="text-xs text-orange-500 hover:text-orange-600 font-medium transition-colors">
                  Fermer ✕
                </button>
              </div>
            </div>
          </div>

          <!-- Message si aucun sélectionné -->
          <p *ngIf="currentTask.executors.length === 0" class="text-xs text-gray-400 mt-2">
            {{ t('taskBoard.form.clickToAssign') }}
          </p>
        </div>
        <!-- ══ fin exécuteurs ══ -->

      </form>
    </div>

    <!-- ── Footer ── -->
    <div class="flex-shrink-0 px-7 py-4 bg-gray-50 border-t border-gray-100 flex justify-end gap-3">
      <button type="button" (click)="closeModal()"
        class="px-5 py-2.5 text-sm font-medium text-gray-600 bg-white border border-gray-200 rounded-xl hover:bg-gray-100 transition-all">
        {{ t('common.cancel') }}
      </button>
      <button type="submit" (click)="saveTask()" [disabled]="loading"
        class="px-5 py-2.5 text-sm font-semibold bg-orange-500 text-white rounded-xl hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm flex items-center gap-2">
        <span *ngIf="loading" class="flex items-center gap-2">
          <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          {{ t('common.saving') }}
        </span>
        <span *ngIf="!loading">{{ isEditMode ? t('common.update') : t('common.create') }}</span>
      </button>
    </div>

  </div>
</div>
<!-- Modal de jointure de fichiers -->
<div *ngIf="showFileModal && currentTaskForFile"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
  (click)="onBackdropClick($event)">

  <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
    <!-- Modal Header -->
    <div class="flex justify-between items-center p-6 border-b border-gray-200">
      <h2 class="text-xl font-semibold text-gray-800">
        {{ t('taskBoard.modal.joinFileTitle') }} - {{ currentTaskForFile.title }}
      </h2>
      <button (click)="closeFileModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="p-6">
      <!-- Fichiers actuels de la tâche -->
      <div *ngIf="currentTaskForFile.pictures && currentTaskForFile.pictures.length > 0" class="mb-6">
        <h3 class="text-sm font-medium text-gray-700 mb-3">{{ t('taskBoard.modal.attachedFiles') }}</h3>
        <div class="grid grid-cols-2 gap-3">
          <div *ngFor="let picture of currentTaskForFile.pictures" class="relative group">
            <img [src]="getFileBaseUrl() + picture" [alt]="currentTaskForFile.title"
              class="w-full h-32 object-cover rounded-lg border border-gray-200">
            <div
              class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all rounded-lg flex items-center justify-center">
              <a [href]="getFileBaseUrl() + picture" target="_blank"
                class="opacity-0 group-hover:opacity-100 text-white bg-blue-600 px-3 py-1 rounded-lg text-sm transition-opacity">
                {{ t('common.view') }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Formulaire de jointure -->
      <form (ngSubmit)="joinFileToTask()" class="space-y-4">
        <div class="border-t border-gray-200 pt-6">
          <h3 class="text-sm font-medium text-gray-700 mb-4">{{ t('taskBoard.modal.addNewFile') }}</h3>

          <!-- Libellé du fichier -->
          <div class="mb-4">
            <label for="fileLibelle" class="block text-sm font-medium text-gray-700 mb-2">
              {{ t('taskBoard.modal.fileLabel') }} *
            </label>
            <input type="text" id="fileLibelle" [(ngModel)]="fileLibelle" name="fileLibelle" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="Ex: Photo du chantier, Document technique...">
          </div>

          <!-- Sélection du fichier -->
          <div class="mb-4">
            <label for="fileToJoin" class="block text-sm font-medium text-gray-700 mb-2">
              {{ t('taskBoard.modal.selectFile') }} *
            </label>
            <div
              class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-orange-500 transition-colors">
              <input type="file" id="fileToJoin" (change)="onFileToJoinSelected($event)" required class="hidden">
              <label for="fileToJoin" class="cursor-pointer">
                <svg class="w-12 h-12 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                  </path>
                </svg>
                <p class="text-sm text-gray-600">
                  <span class="text-orange-500 font-medium">{{ t('taskBoard.modal.clickToSelect') }}</span>
                  {{ t('taskBoard.modal.dragDrop') }}
                </p>
                <p class="text-xs text-gray-500 mt-1">
                  PNG, JPG, PDF jusqu'à 10MB
                </p>
              </label>
            </div>
            <p *ngIf="fileToJoin" class="text-sm text-green-600 mt-2 flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
              {{ t('taskBoard.modal.selectedFile') }}: {{ fileToJoin.name }}
            </p>
          </div>

          <!-- Error Message -->
          <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {{ error }}
          </div>

          <!-- Actions -->
          <div class="flex justify-end gap-3 pt-4">
            <button type="button" (click)="closeFileModal()"
              class="px-6 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
              {{ t('common.cancel') }}
            </button>
            <button type="submit" [disabled]="loadingFileJoin || !fileToJoin || !fileLibelle"
              class="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
              <span *ngIf="loadingFileJoin" class="flex items-center gap-2">
                <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                  </path>
                </svg>
                {{ t('taskBoard.modal.joining') }}
              </span>
              <span *ngIf="!loadingFileJoin">{{ t('taskBoard.modal.joinFileButton') }}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal de détails de la tâche - Version Premium -->
<div *ngIf="showDetailModal && selectedTask"
  class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50 backdrop-blur-sm"
  (click)="onBackdropClick($event)">

  <div class="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[85vh] overflow-hidden">
    <!-- Modal Header -->
    <div class="relative bg-white px-8 py-6 border-b border-gray-200">
      <div class="flex justify-between items-start">
        <div class="flex-1">
          <h2 class="text-2xl font-bold text-gray-900 mb-2">{{ selectedTask.title }}</h2>
          <div class="flex items-center gap-3">
            <!-- Badge de statut -->
            <span
              class="inline-flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-full text-sm font-medium text-gray-700">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"></path>
              </svg>
              {{ getStatusColumnTitle(selectedTask.status) }}
            </span>

            <!-- Badge de priorité -->
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold"
              [ngClass]="[selectedTask.tag.colorClass, selectedTask.tag.textColorClass]">
              {{ selectedTask.tag.name }}
            </span>
          </div>
        </div>

        <button (click)="closeDetailModal()" class="text-gray-400 hover:text-gray-600 rounded-full p-2 transition-all">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal Content avec scroll -->
    <div class="overflow-y-auto" style="max-height: calc(85vh - 200px);">
      <div class="p-8 space-y-6">

        <!-- Images de la tâche - Galerie moderne -->
        <div *ngIf="selectedTask.pictures && selectedTask.pictures.length > 0"
          class="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
          <div class="flex items-center gap-2 mb-4">
            <div class="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                </path>
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-800">{{ t('taskBoard.detail.gallery') }}</h3>
            <span class="ml-auto text-sm text-gray-500">{{ selectedTask.pictures.length }} {{ t('statusReport.photos')
              }}</span>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
            <div *ngFor="let picture of selectedTask.pictures"
              class="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
              <img [src]="getFileBaseUrl() + picture" [alt]="selectedTask.title"
                class="w-full h-48 object-cover transform group-hover:scale-110 transition-transform duration-300">
              <div
                class="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 group-hover:opacity-60 transition-opacity">
                <div class="absolute bottom-3 left-3 right-3 flex justify-center">
                  <a [href]="getFileBaseUrl() + picture" target="_blank"
                    class="bg-white text-gray-900 px-4 py-2 rounded-lg text-sm font-medium transform translate-y-4 group-hover:translate-y-0 transition-transform">
                    {{ t('taskBoard.detail.viewBig') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Description avec style carte -->
        <div class="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
          <div class="flex items-center gap-2 mb-3">
            <div class="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                </path>
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-800">{{ t('taskBoard.form.description') }}</h3>
          </div>
          <p class="text-gray-700 leading-relaxed pl-12">{{ selectedTask.description }}</p>
        </div>

        <!-- Informations en grille -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

          <!-- Dates -->
          <div class="bg-white rounded-xl p-5 border border-gray-200 shadow-sm">
            <div class="flex items-center gap-3 mb-4">
              <div class="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                  </path>
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-800">{{ t('taskBoard.detail.period') }}</h3>
            </div>
            <div class="space-y-3 pl-1">
              <div class="flex items-center gap-3">
                <span class="text-sm font-medium text-gray-600 w-20">{{ t('taskBoard.detail.start') }}:</span>
                <span class="text-sm font-semibold text-gray-900 bg-gray-50 px-3 py-1 rounded-lg">
                  {{ formatDate(selectedTask.startDate) }}
                </span>
              </div>
              <div class="flex items-center gap-3">
                <span class="text-sm font-medium text-gray-600 w-20">{{ t('taskBoard.detail.end') }}:</span>
                <span class="text-sm font-semibold text-gray-900 bg-gray-50 px-3 py-1 rounded-lg">
                  {{ selectedTask.dueDate }}
                </span>
              </div>
            </div>
          </div>

          <!-- Métriques -->
          <div class="bg-white rounded-xl p-5 border border-gray-200 shadow-sm">
            <div class="flex items-center gap-3 mb-4">
              <div class="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z">
                  </path>
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-800">{{ t('taskBoard.detail.stats') }}</h3>
            </div>
            <div class="grid grid-cols-2 gap-3">
              <div class="bg-gray-50 rounded-lg p-3 text-center">
                <div class="text-2xl font-bold text-gray-900">{{ 0 }}</div>
                <div class="text-xs text-gray-600 mt-1">{{ t('taskBoard.task.comments') }}</div>
              </div>
              <div class="bg-gray-50 rounded-lg p-3 text-center">
                <div class="text-2xl font-bold text-gray-900">{{ selectedTask.attachments }}</div>
                <div class="text-xs text-gray-600 mt-1">{{ t('taskBoard.task.attachments') }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Exécuteurs assignés - Style moderne avec pagination -->
        <div *ngIf="selectedTask.executors && selectedTask.executors.length > 0"
          class="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
          <div class="flex items-center gap-3 mb-5">
            <div class="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
                </path>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-semibold text-gray-800">{{ t('taskBoard.detail.assignedTeam') }}</h3>
              <p class="text-sm text-gray-600">{{ selectedTask.executors.length }} {{ t('taskBoard.task.members') }}</p>
            </div>
            <!-- Pagination controls -->
            <div *ngIf="totalExecutorPages > 1" class="flex items-center gap-2">
              <button (click)="prevExecutorPage()" [disabled]="executorPage === 0"
                class="w-8 h-8 rounded-lg border border-gray-300 flex items-center justify-center disabled:opacity-30 hover:bg-gray-100 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
              </button>
              <span class="text-xs text-gray-500 font-medium">{{ executorPage + 1 }}/{{ totalExecutorPages }}</span>
              <button (click)="nextExecutorPage()" [disabled]="executorPage >= totalExecutorPages - 1"
                class="w-8 h-8 rounded-lg border border-gray-300 flex items-center justify-center disabled:opacity-30 hover:bg-gray-100 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>
          <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <div *ngFor="let executor of pagedExecutors"
              class="flex flex-col items-center gap-2 bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors border border-gray-200">
              <div class="relative">
                <img [src]="executor.photo ? getFileBaseUrl() + executor.photo : '/avatar-placeholder.svg'"
                  class="w-12 h-12 rounded-full object-cover border-2 border-gray-300" (error)="onImageError($event)">
                <div class="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
              </div>
              <div class="text-center min-w-0 w-full">
                <p class="text-sm font-semibold text-gray-900 truncate">{{ getExecutorDetails(executor) }}</p>
                <p class="text-xs text-gray-500">{{ t('taskBoard.detail.executor') }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Section vide pour les exécuteurs -->
        <div *ngIf="!selectedTask.executors || selectedTask.executors.length === 0"
          class="bg-gray-50 rounded-xl p-8 border-2 border-dashed border-gray-300 text-center">
          <svg class="w-16 h-16 mx-auto mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z">
            </path>
          </svg>
          <p class="text-gray-600 font-medium">{{ t('taskBoard.detail.noExecutor') }}</p>
          <p class="text-sm text-gray-500 mt-1">{{ t('taskBoard.detail.clickEditToAssign') }}</p>
        </div>

      </div>
    </div>

    <!-- Modal Footer avec actions - Toujours visible -->
    <div class="bg-gray-50 px-8 py-4 border-t border-gray-200 flex-shrink-0">
      <div class="flex flex-wrap gap-3 justify-end">

        <button (click)="closeDetailModal()"
          class="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg hover:from-orange-600 hover:to-orange-700 font-medium shadow-lg shadow-orange-500/30 hover:shadow-xl hover:shadow-orange-500/40 transition-all">
          <span class="flex items-center gap-2">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
            Fermer
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

